import useMountEffect from '@restart/hooks/useMountEffect';
import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import classNames from 'classnames/bind';
import React, { useState } from 'react';
import { Joystick } from 'react-joystick-component';

import styles from './index.module.scss';

import BinarySwitch from '@/components/ui/BinarySwitch';
import useActionCommand from '@/hooks/command/mavlink/useActionCommand';
import EventEmitter from '@/libs/EventEmitter';

const cx = classNames.bind(styles);

const Panel = ({ data: robots }) => {
  const [isVirtualJoystick, setIsVirtualJoystick] = useState(true);
  const [joystickPosition, setJoystickPosition] = useState({ x: 0, y: 0 });

  const actionCommand = useActionCommand();

  useMountEffect(() => {
    actionCommand.manual(robots[0]);
    EventEmitter.publish(`${robots[0].id}/event/removeGoto`);

    return () => {
      actionCommand.hold(robots[0]);
    };
  });

  useUpdateEffect(() => {
    if (isVirtualJoystick) return;

    let frameId;
    const handleJoystick = () => {
      const joystick = navigator.getGamepads()[0];
      if (joystick) {
        moveJoystick({
          x: joystick.axes[0],
          y: -joystick.axes[1],
        });
      }

      frameId = window.requestAnimationFrame(handleJoystick);
    };

    handleJoystick();

    return () => {
      window.cancelAnimationFrame(frameId);
      stopJoystick();
    };
  }, [isVirtualJoystick]);

  const selectSwitch = (e) => {
    setIsVirtualJoystick(e.currentTarget.dataset.value === 'true');
  };

  const moveJoystick = ({ x, y }) => {
    EventEmitter.publish(`${robots[0].id}/set/stickControl`, {
      y: y > 0 ? Math.trunc(x * 1000) : -Math.trunc(x * 1000),
      z: Math.trunc(y * 1000),
    });

    setJoystickPosition({ x, y });
  };

  const stopJoystick = () => {
    EventEmitter.publish(`${robots[0].id}/set/stickControl`, {
      y: 0,
      z: 0,
    });

    setJoystickPosition({ x: 0, y: 0 });
  };

  return (
    <div className={cx('container')}>
      <BinarySwitch
        items={[
          { title: 'Virtual', value: true, onClick: selectSwitch },
          { title: 'Real', value: false, onClick: selectSwitch },
        ]}
      />
      <div className={cx(['joystick', { inactive: !isVirtualJoystick }])}>
        <Joystick
          size={120}
          stickSize={64}
          sticky={false}
          stickImage={require('./joystick-blue.png')}
          baseImage={require('./joystick-base.png')}
          move={moveJoystick}
          stop={stopJoystick}
          pos={joystickPosition}
          disabled={!isVirtualJoystick}
        />
        <div className={cx('info')}>
          <div className={cx('item')}>{joystickPosition.x.toFixed(2)}</div>
          <div className={cx('item')}>{joystickPosition.y.toFixed(2)}</div>
        </div>
      </div>
    </div>
  );
};

export default Panel;
